import React from "react";
import { AppointmentTemplate } from "../../components/templates";

function Appointment() {
  return <AppointmentTemplate />;
}

export default Appointment;
